/* eslint-disable import/order */
/* eslint-disable import/no-extraneous-dependencies */
import { ToastContainer } from 'react-toastify'

import { SearchIcon } from '../../assets/icons/search'
import { colors } from '../../theme'
import {
  Container,
  // SpanFilter,
  // Ul,
} from '../../layouts/LayoutTable/LayoutTable'
import { GenericTable } from '../../components/GenericTable/GenericTable'
import 'dayjs/locale/pt-br'

import { Button } from '../../components/SideBar/Menu.style'
import { DivTitle } from '../../components/TitlePage/TitlePage'
import { Pagination } from '../../components/Pagination/Pagination'
import { Loading } from '../../components/Loading/Loading'
import { useSales } from './useSales'
import {
  DivFilter,
  TypesFilter,
  // SearchCompanies,
  FilterCompanie,
  FilterClient,
  FilterProduct,
  FilterSalesPeople,
  FilterSegmento,
  FilterCategoria,
  Filters,
  Calendars,
  OptionActive,
  Option,
  Filtro,
  DatePickerStyle,
  Span,
  InputStyle,
  DivInput,
  ContainerInput,
  FiltersCalendar,
  TypesFilterCalendar,
} from './Sales.style'
import { CityBlack } from '../../assets/icons/cityBlack'
import { ArrowDown } from '../../assets/icons/arrowDown'
import { UserBlack } from '../../assets/icons/userBlack'
import { UserPositioning } from '../../assets/icons/user-positioning'
import { AdProduct } from '../../assets/icons/ad-product'
// import { CalendarIcon1 } from '../../assets/icons/calendar1'
// import { ItemFilter } from '../../components/ItemFilter/ItemFilter'

import { dateToBr } from '../../utils/transformDate'
// import {
//   useCalendarFim,
//   useCalendarInicio,
// } from '../../components/Calendar/useCalendar'
import SelectCompanie from '../../components/MultipleSelect'
import SelectTexto from '../../components/MultipleSelect/SelectTexto'
import { rotuloCategoria } from '../../components/MultipleSelect/rotuloCategoria'
import PeriodPicker from '../../components/Calendar/rangePicker'
import { Export } from '../Predictions/Predictions.style'
import Clear from '../../assets/icons/clear'
import { useFiltrosCatalogo } from '../../hooks/useFiltrosCatalogo'

export function Sales() {
  // Buscado aqui, e nao dentro de useSales: aquele hook e instanciado varias vezes por tela
  // (SelectCompanie tambem o chama), o que multiplicaria as requisicoes do catalogo.
  const { segmentos, categorias, carregandoCatalogo } = useFiltrosCatalogo()
  const {
    searchValue,
    setSearchValue,
    currentPage,
    setCurrentPage,
    sales,
    isLoading,
    handleKeyDown,
    handleKeyClosed,
    fetchSales,
    handleShowFilterCompanies,
    handleShowFilterClient,
    handleShowFilterProducts,
    handleShowFilterSalesPeople,
    handleShowFilterDate,
    showCompanies,
    showClient,
    showProducts,
    showSalesPeople,
    companies,
    clients,
    vendedores,
    produto,
    setValueCompanieId,
    setValueClientId,
    setValueProductId,
    setValueSalesPeopleId,
    setCalendarInicio,
    setCalendarFim,
    arrayClientes,
    arrayVendedores,
    arrayProdutos,
    arrayEmpresas,
    selectedOptionsSalesPeople,
    selectedOptionsProduct,
    selectedOptionsClient,
    selectedOptionsCompanie,
    salesPeopleArray,
    productArray,
    companieArray,
    clientArray,
    setValueSalesPeople,
    setValueClient,
    setValueProduct,
    setValueCompanie,
    valueCompanie,
    valueClient,
    valueProduct,
    valueSalesPeople,
    formatarCPF,
    dateStart,
    setDateStart,
    dateEnd,
    setDateEnd,
    handleReload,

    handleShowFilterSegmento,
    handleShowFilterCategoria,
    showSegmento,
    showCategoria,
    valueSegmento,
    setValueSegmento,
    valueCategoria,
    setValueCategoria,
    aplicarSegmento,
    aplicarCategoria,
  } = useSales()

  return (
    <div>
      <ToastContainer theme="dark" />
      <DivTitle color="black" size={22}>
        Vendas
      </DivTitle>
      <Container>
        <DivInput>
          <DivFilter>
            <ContainerInput>
              <InputStyle
                value={searchValue}
                onChange={event => setSearchValue(event.target.value)}
                onKeyDown={handleKeyDown}
                border={colors.grey300}
                placeholder="Pesquisar palavra chave "
                sizeX="220px"
                sizeY="42px"
              />
              <Span onClick={fetchSales}>
                <SearchIcon />
              </Span>
            </ContainerInput>

            {/* <SpanIcon onClick={showFilter}>
              <FilterIcon />
            </SpanIcon> */}
            <TypesFilter>
              <Filters
                type="button"
                // eslint-disable-next-line jsx-a11y/tabindex-no-positive
                onKeyDown={handleKeyClosed}
                onClick={handleShowFilterCompanies}
              >
                <CityBlack /> Empresa <ArrowDown />
              </Filters>
            </TypesFilter>
            {showCompanies && (
              <FilterCompanie onKeyDown={handleKeyClosed}>
                {/* <SpanFilter>
            <SearchCompanies type="text" placeholder="Pesquisar empresa" />
            <SearchIcon />
          </SpanFilter> */}
                <Filtro>
                  {isLoading ? (
                    <Loading contrast={false} />
                  ) : (
                    <SelectCompanie
                      value={valueCompanie}
                      handle={setValueCompanie}
                      array={arrayEmpresas ? companies : []}
                    />
                  )}
                  {/* <Ul>
              {companies.map(empresa => (
                <ItemFilter
                  key={empresa.id}
                  onChange={() => setEmpresaId(empresa.id)}
                  text={empresa.nome}
                  id="all"
                />
              ))}
            </Ul> */}
                  <Button
                    buttonType="SMALL"
                    type="button"
                    onClick={() => {
                      setValueCompanieId(companieArray)
                      handleShowFilterCompanies()
                    }}
                  >
                    Aplicar
                  </Button>
                </Filtro>
              </FilterCompanie>
            )}
            <TypesFilter>
              <Filters
                type="button"
                onKeyDown={handleKeyClosed}
                onClick={handleShowFilterSalesPeople}
              >
                <UserBlack /> Vendedor <ArrowDown />
              </Filters>
            </TypesFilter>
            {showSalesPeople && (
              <FilterSalesPeople onKeyDown={handleKeyClosed}>
                {/* <SpanFilter>
            <SearchCompanies type="text" placeholder="Pesquisar vendedor" />
            <SearchIcon />
          </SpanFilter> */}
                {/* <Ul>
              {vendedores.map(vendedor => (
                <ItemFilter
                  key={vendedor.id}
                  onChange={() => setVendedorId(vendedor.id)}
                  text={vendedor.nome}
                  id="all"
                />
              ))}
            </Ul> */}
                <Filtro>
                  {isLoading ? (
                    <Loading contrast={false} />
                  ) : (
                    <SelectCompanie
                      value={valueSalesPeople}
                      handle={setValueSalesPeople}
                      array={arrayVendedores ? vendedores : []}
                    />
                  )}
                  <Button
                    buttonType="SMALL"
                    type="button"
                    // onClick={fetchSales}
                    onClick={() => {
                      setValueSalesPeopleId(salesPeopleArray)
                      handleShowFilterSalesPeople()
                    }}
                  >
                    Aplicar
                  </Button>
                </Filtro>
              </FilterSalesPeople>
            )}
            <TypesFilter>
              <Filters
                type="button"
                onKeyDown={handleKeyClosed}
                onClick={handleShowFilterClient}
              >
                <UserPositioning /> Cliente <ArrowDown />
              </Filters>
            </TypesFilter>
            {showClient && (
              <FilterClient onKeyDown={handleKeyClosed}>
                {/* <SpanFilter>
            <SearchCompanies type="text" placeholder="Pesquisar cliente" />
            <SearchIcon />
          </SpanFilter> */}
                {/* <Ul>
              {clients.map(cliente => (
                <ItemFilter
                  key={cliente.id}
                  onChange={() => setClienteId(cliente.id)}
                  text={cliente.nome}
                  id="all"
                />
              ))}
            </Ul> */}
                <Filtro>
                  {isLoading ? (
                    <Loading contrast={false} />
                  ) : (
                    <SelectCompanie
                      value={valueClient}
                      handle={setValueClient}
                      array={arrayClientes ? clients : []}
                    />
                  )}
                  <Button
                    buttonType="SMALL"
                    type="button"
                    onClick={() => {
                      setValueClientId(clientArray)
                      handleShowFilterClient()
                    }}
                  >
                    Aplicar
                  </Button>
                </Filtro>
              </FilterClient>
            )}

            <TypesFilter>
              <Filters
                type="button"
                onKeyDown={handleKeyClosed}
                onClick={handleShowFilterProducts}
              >
                <AdProduct /> Produto <ArrowDown />
              </Filters>
            </TypesFilter>
            {showProducts && (
              <FilterProduct onKeyDown={handleKeyClosed}>
                {/* <SpanFilter>
            <SearchCompanies type="text" placeholder="Pesquisar produto" />
            <SearchIcon />
          </SpanFilter> */}
                <Filtro>
                  {isLoading ? (
                    <Loading contrast={false} />
                  ) : (
                    <SelectCompanie
                      value={valueProduct}
                      handle={setValueProduct}
                      array={arrayProdutos ? produto : []}
                    />
                  )}
                  <Button
                    buttonType="SMALL"
                    type="button"
                    onClick={() => {
                      setValueProductId(productArray)
                      handleShowFilterProducts()
                    }}
                  >
                    Aplicar
                  </Button>
                </Filtro>
              </FilterProduct>
            )}

            <TypesFilter>
              <Filters
                type="button"
                onKeyDown={handleKeyClosed}
                onClick={handleShowFilterSegmento}
              >
                <UserPositioning /> Segmento <ArrowDown />
              </Filters>
            </TypesFilter>
            {showSegmento && (
              <FilterSegmento onKeyDown={handleKeyClosed}>
                <Filtro>
                  <SelectTexto
                    opcoes={segmentos}
                    value={valueSegmento}
                    handle={setValueSegmento}
                    placeholder="Selecione um ou mais segmentos"
                    carregando={carregandoCatalogo}
                    vazio="Nenhum segmento cadastrado"
                  />
                  <Button
                    buttonType="SMALL"
                    type="button"
                    onClick={aplicarSegmento}
                  >
                    Aplicar
                  </Button>
                </Filtro>
              </FilterSegmento>
            )}

            <TypesFilter>
              <Filters
                type="button"
                onKeyDown={handleKeyClosed}
                onClick={handleShowFilterCategoria}
              >
                <AdProduct /> Categoria <ArrowDown />
              </Filters>
            </TypesFilter>
            {showCategoria && (
              <FilterCategoria onKeyDown={handleKeyClosed}>
                <Filtro>
                  <SelectTexto
                    opcoes={categorias}
                    value={valueCategoria}
                    handle={setValueCategoria}
                    placeholder="Selecione uma ou mais categorias"
                    carregando={carregandoCatalogo}
                    vazio="Nenhuma categoria cadastrada"
                    rotulo={rotuloCategoria}
                  />
                  <Button
                    buttonType="SMALL"
                    type="button"
                    onClick={aplicarCategoria}
                  >
                    Aplicar
                  </Button>
                </Filtro>
              </FilterCategoria>
            )}
            <TypesFilter>
              <Export
                type="button"
                // eslint-disable-next-line jsx-a11y/tabindex-no-positive
                onKeyDown={handleKeyClosed}
                onClick={() => {
                  setValueSalesPeople([])
                  setValueClient([])
                  setValueCompanie([])
                  setValueProduct([])
                  setValueProductId([])
                  setValueCompanieId([])
                  setValueSalesPeopleId([])
                  setValueClientId([])
                  setValueSegmento([])
                  setValueCategoria([])
                  handleReload()
                }}
              >
                <Clear />
                Limpar
              </Export>
            </TypesFilter>
            <TypesFilterCalendar>
              <FiltersCalendar
                onKeyDown={handleKeyClosed}
                onClick={handleShowFilterDate}
              >
                <Calendars>
                  <DatePickerStyle>
                    {/* <CalendarIcon1 /> */}
                    Período:
                    <PeriodPicker
                      handlePeriodoSelecionado={(inicio, fim) => {
                        setDateStart(inicio)
                        setDateEnd(fim)
                      }}
                      size="250px"
                    />
                  </DatePickerStyle>
                </Calendars>
                <Button
                  buttonType="SMALL"
                  type="button"
                  onClick={() => {
                    handleShowFilterDate()
                    setCalendarInicio(dateStart)
                    setCalendarFim(dateEnd)
                  }}
                >
                  Aplicar
                </Button>
              </FiltersCalendar>
            </TypesFilterCalendar>
          </DivFilter>

          <OptionActive>
            {selectedOptionsCompanie &&
              selectedOptionsCompanie.map(option => (
                <Option key={option}>
                  <strong>Empresa: </strong>
                  {option}
                  {/* <ButtonClosedOption
                    type="button"
                    onClick={() => handleDeleteOption(option)}
                  >
                    <CloseOption />
                  </ButtonClosedOption> */}
                </Option>
              ))}
            {selectedOptionsClient &&
              selectedOptionsClient.map(option => (
                <Option key={option}>
                  <strong>Cliente: </strong>
                  {option}
                  {/* <ButtonClosedOption
                    type="button"
                    onClick={() => handleDeleteOption(option)}
                  >
                    <CloseOption />
                  </ButtonClosedOption> */}
                </Option>
              ))}
            {selectedOptionsProduct &&
              selectedOptionsProduct.map(option => (
                <Option key={option}>
                  <strong>Produto: </strong>
                  {option}
                  {/* <ButtonClosedOption
                    type="button"
                    onClick={() => handleDeleteOption(option)}
                  >
                    <CloseOption />
                  </ButtonClosedOption> */}
                </Option>
              ))}
            {selectedOptionsSalesPeople &&
              selectedOptionsSalesPeople.map(option => (
                <Option key={option}>
                  <strong>Vendedor: </strong>
                  {option}
                  {/* <ButtonClosedOption
                    type="button"
                    onClick={() => handleDeleteOption(option)}
                  >
                    <CloseOption />
                  </ButtonClosedOption> */}
                </Option>
              ))}
            {valueSegmento.map(option => (
              <Option key={option}>
                <strong>Segmento: </strong>
                {option}
              </Option>
            ))}
            {valueCategoria.map(option => (
              <Option key={option}>
                <strong>Categoria: </strong>
                {option}
              </Option>
            ))}
          </OptionActive>
          <div>
            {isLoading ? (
              <Loading contrast={false} />
            ) : (
              <>
                <GenericTable
                  size="270px"
                  headers={[
                    'Empresa',
                    'Vendedor',
                    'Cliente',
                    'Data venda',
                    'Produto',
                    'Qtd.',
                  ]}
                  spacing="20px"
                  font="16px"
                  vendas
                  text
                  title5
                >
                  {sales.content &&
                    sales.content.map(vendas => (
                      <tr
                        // onClick={() => goToPage(produto.id)}
                        key={vendas.id}
                      >
                        <td className="colVendas7">
                          {vendas.empresa.nome}
                          <br />
                          CNPJ: {formatarCPF(vendas.empresa.cpfcnpj)}
                        </td>
                        <td className="colVendas7">
                          {vendas.vendedor.nome}
                          <br />
                          CPF: {formatarCPF(vendas.vendedor.cpfcnpj)}
                        </td>
                        <td className="colVendas7">
                          {vendas.cliente.nome}
                          <br />
                          CNPJ/CPF: {formatarCPF(vendas.cliente.cpfcnpj)}
                        </td>
                        <td className="colVendas6">
                          {dateToBr(vendas.dataVenda)}
                        </td>
                        <td className="colVendas7">{vendas.produto.nome}</td>
                        <td className="col3">{vendas.quantidade}</td>
                      </tr>
                    ))}
                </GenericTable>
                <Pagination
                  pageNumber={currentPage}
                  pageSize={sales.totalElements}
                  offSet={sales.size}
                  onClick={page => setCurrentPage(page)}
                />
              </>
            )}
          </div>
        </DivInput>
      </Container>
    </div>
  )
}
